<template>
    <div>
        <div class="kgr grid kgr-grid--inline kgr-grid--gutters">
            <div class="kgr-grid__cell">
                <div class="kgr-inputGroup date-picker"
                     :class="{ invalid: !dateRangeValid }"
                >
                    <label class="kgr-inputGroup__label">{{ $t('Von') }}</label>
                    <kgr-date-picker
                        v-model="start"
                    />
                </div>
            </div>
            <div class="kgr-grid__cell">
                <div class="kgr-inputGroup date-picker"
                     :class="{ invalid: !dateRangeValid }"
                >
                    <label class="kgr-inputGroup__label">{{ $t('Bis') }}</label>
                    <kgr-date-picker
                        v-model="end"
                    />
                </div>
            </div>
            <div class="kgr-grid__cell">
                <div class="kgr-inputGroup">
                    <label class="kgr-inputGroup__label">&nbsp;</label>
                    <kgr-button
                        :disabled="loading"
                        @click="onDateChange">
                        {{ $t('Anzeigen') }}
                    </kgr-button>
                </div>
            </div>
        </div>
        <div v-if="!dateRangeValid" class="kgr grid kgr-grid--gutters kgr-row kgr-inputGroup__text--error">
            <div class="kgr-grid__cell">{{ $t('Das Startdatum darf nicht nach dem Enddatum liegen.')}}</div>
        </div>
        <div class="kgr-row"></div>

        <kgr-loader inline v-if="loading" />
        <template v-if="!loading">
            <kgr-mail
                v-for="mailHistory in mailHistories"
                :mail-history="mailHistory"
                :key="mailHistory.id"
            />
            <kgr-empty-data
                v-if="!loading && mailHistories.length === 0"
                :value="$t('Für den Zeitraum liegen keine Einträge vor.')"
            />
        </template>
    </div>
</template>

<script>

import DatePicker from '../../components/common/form/picker/DatePicker.vue';
import EmptyData from '../../components/common/EmptyData.vue';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import Loader from '../../components/common/Loading.vue';
import Mail from '../../components/mail-history/Mail';
import axios from 'axios';
import moment from 'moment';

export default {
    components: {
        KgrButton,
        'kgr-empty-data': EmptyData,
        'kgr-loader': Loader,
        'kgr-mail': Mail,
        'kgr-date-picker': DatePicker,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            mailHistories: [],
            loading: true,
            dateRangeValid: true,
            start: moment(new Date(), 'YYYY-MM-DD').subtract(14, 'd').format('DD.MM.YYYY'),
            end: moment(new Date(), 'YYYY-MM-DD').format('DD.MM.YYYY'),
        }
    },
    methods: {
        onDateChange() {
            this.loading = true;
            if (!this.isValidDateRange()) {
                this.loading = false;
                return;
            }
            this.getData();
        },
        isValidDateRange() {
            if (moment(this.start, 'DD.MM.YYYY') <= moment(this.end, 'DD.MM.YYYY')) {
                this.dateRangeValid = true;
                return true;
            } else {
                this.dateRangeValid = false;
                return false;
            }
        },
        getData() {
            let start = moment(this.start, 'DD.MM.YYYY').format('YYYY-MM-DD');
            let end = moment(this.end, 'DD.MM.YYYY').format('YYYY-MM-DD');
            let query = '?dateRange=' + start + ':' + end;
            axios
                .get(`/kindergartens/${this.kindergartenId}/mail-history${query}`)
                .then(response => {
                    this.mailHistories = response.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.$notify.error('Daten konnten nicht geladen werden');
                    this.loading = false;
                });
        }
    },
    created() {
        this.getData()
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

div .date-picker {
    border: 1px solid transparent;

    &.invalid input[type=text] {
        border: 1px solid #F44336;
    }
}
</style>
